import React from 'react';
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import { authentication } from '../../app-database';
import { conectarFirebase } from '../../app-persistance';
import AutosProducto from '../../home/productos/autosProducto.cmpt';
import GastosProducto from '../../home/productos/gastosProducto.cmpt';
import VidaProducto from '../../home/productos/vidaProducto.cmpt';
import DaniosProducto from '../../home/productos/daniosProducto.cmpt';

const mapDispatch = (dispatch) => {
    return {}
}

class Productos extends React.Component {
  state = {
    "tabAutos": true,
    "tabGastos": false,
    "tabVida": false,
    "tabDanios": false,
  }

    componentDidMount = () => {
        let $this = this;
        authentication.onAuthStateChanged(function(user) {
            if (user) {
                let redux = angular.element(document.querySelector('ui-view')).scope().$parent.state.redux;

                redux.dispatch({ "type": "CVE_CLIENTE_UNICO", "uid": authentication.currentUser.uid });
                conectarFirebase(redux);
            }
        });
    }
    selectTab = (tab) => {
      console.log(tab);
      var temporal = {
        "tabAutos": false,
        "tabGastos": false,
        "tabVida": false,
        "tabDanios": false,
      }
      temporal[tab] = true;
      this.setState(temporal);
    }

    render() {
        return <div className="productos-nativo">
              <div id="menu-productos-nativo" className="second-menu text-center">
                <ul className="clearfix">
                  <li><a className={this.state.tabAutos ? "active" : ""} onClick={this.selectTab.bind(this, "tabAutos")}>Autos</a></li>
                  <li><a className={this.state.tabGastos ? "active" : ""} onClick={this.selectTab.bind(this, "tabGastos")}>GMM</a></li>
                  <li><a className={this.state.tabVida ? "active" : ""} onClick={this.selectTab.bind(this, "tabVida")}>Vida</a></li>
                  <li><a className={this.state.tabDanios ? "active" : ""} onClick={this.selectTab.bind(this, "tabDanios")}>Daños</a></li>
                </ul>
              </div>
              {this.state.tabAutos &&
                <AutosProducto showArrow={false}  />
              }
              {this.state.tabGastos &&
                <GastosProducto showArrow={false}  />
              }
              {this.state.tabVida &&
                <VidaProducto showArrow={false}  />
              }
              {this.state.tabDanios &&
                <DaniosProducto showArrow={false}  />
              }
        </div>;
    }
}
export default connect (null, mapDispatch)(Productos);



// WEBPACK FOOTER //
// ./src/movil/productos/productos.cmpt.js